<template>
  <div class="register">
    <login-register>
			<findPassWord/>
		</login-register>
  </div>
</template>

<script>
import LoginRegister from '@/components/LoginRegister.vue'
import findPassWord from '@/components/findPassWord/findPassWord.vue'
export default {
	name: 'register',
	components: {
		LoginRegister,
		findPassWord
	}
}
</script>

<style lang="stylus" scoped>
.register {
	display flex
	flex: 1
}
</style>
